export default "__VITE_ASSET__CgbZ4sW7__"